import { enUS, et, fi, lt, lv, ru } from 'date-fns/locale';
import { getCookie } from '@/utils/cookies';
import { DEFAULT_LOCALE } from '@/constants/locales';

const locales = {
	eng: enUS,
	est: et,
	fin: fi,
	lat: lv,
	lit: lt,
	rus: ru,
};

/**
 * Get the date-fns locale object for the currently active language.
 */
export const getCurrentDateFnsLocale = () => {
	const lang = (getCookie('sapi_language') ??
		DEFAULT_LOCALE) as keyof typeof locales;

	return locales[lang];
};
